import { Icon } from 'ant-design-vue';

export default Icon.createFromIconfontCN({
  // scriptUrl: "//at.alicdn.com/t/font_2453794_tszc5e5hanf.js",
  scriptUrl: '//at.alicdn.com/t/c/font_2453794_02b8ehevw7el.js',
});
